<template>
    <v-flex style="height: 100%;">
      <v-toolbar
          color="primary"
          dark
          flat
          style="z-index: 2;"
        >
          <v-toolbar-title>Fahrer: {{ completeTour.driver.firstname + ' ' + completeTour.driver.lastname  }} &nbsp; | &nbsp;  iPad: {{ completeTour.device }} &nbsp; | &nbsp; Fahrzeug: {{ completeTour.kfz }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down" v-if="buttonActive">
            <v-btn icon @click="refresh">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      <v-card style="height: 100%; position: relative;">

        <v-alert type="error" style="display: flex; margin-top: 0px; margin-bottom: 0px;" v-if="waypoints['tour'].length == 0"> 
          Es wurden keine Koordinaten durch den Fahrer übermittelt.
        </v-alert>

        <LiefermaxMap style="width: 100%; height: 40%;"
          :key="mapKey"
          :waypoints="waypoints"
          :stopOver="showCalculatedTour"
          :drivenTour="showDrivenTour"
          :showMarker="showMarker"
        ></LiefermaxMap>
        
    
        
        <v-layout row wrap style="height: 60%;">
        <v-flex xs12>
          <v-card style="height: 100%;">
            <v-layout align-center justify-center justify-space-around row>
        <v-flex xs2>
          <v-checkbox
            v-model="showMarker"
            label="Zeige Marker"
          ></v-checkbox>
      </v-flex>
      <v-flex xs2>
        <v-chip color="green" text-color="white">
      <v-avatar>
        <v-icon>check_circle</v-icon>
      </v-avatar>
Erledigt: {{ doneCount() }} / {{ doneCount() + openCount() }}
    </v-chip>
      </v-flex>
      <v-flex xs2>
          <!-- <v-switch v-model="showCalculatedTour" :label="switchLabel"></v-switch> -->
            <v-checkbox
              v-model="showDrivenTour"
              label="Zeige gefahrene Route"
               color="blue"
               v-if="waypoints['tour'].length > 0"
            ></v-checkbox>
            <v-checkbox
              v-model="showCalculatedTour"
              label="Zeige errechnete Route"
               color="red"
            > </v-checkbox>
      </v-flex>
    </v-layout>
        <v-data-table
          :key="tableKey"
          :headers="headers"
          :items="completeTour.contracts"
          :expand="expand"
          :rows-per-page-text="perPageText"
          :pagination.sync="pagination"
          style="padding: 5%;"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded" :class="{ 'deleted': props.item.deleted, 'finished': props.item.done }">
              <td class="text-xs-left"> {{ props.item.sorting + 1 }} </td>
              <td>{{ props.item.contractNumber }}</td>
              <td>{{ props.item.absa }}</td>
              <td class="text-xs-right">{{ props.item.customer.name }}</td>
              <td class="text-xs-right">{{ props.item.done ? props.item.doneAt : props.item.deleted ? props.item.deletedAt : '' | formatDate }}</td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card>
              <div>
                <span>Absatzstätte: {{ props.item.customer.absa }} <br/> {{ props.item.customer.name }}</span> <br/>
                <span>{{ props.item.customer.street }} <br/> {{ props.item.customer.zip + ' ' + props.item.customer.city}}</span> <br/>
                <b><span>{{ deliveredOrDeleted(props.item) }}</span></b>
              </div>
            </v-card>
          </template>
        </v-data-table>
          </v-card>
        </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
</template>

<script>
import LiefermaxMap from '../components/LiefermaxMap.vue';
export default {
  components: {
    LiefermaxMap
  },
  computed: {
    completeTour() {
      return this.$store.state.tours.completeTour.items.tour;
    },
    loadnoSpecific() {
      return this.$store.state.locations.loadnoSpecific;
    },
    waypoints() {
      var points = [];
      var pointsCalculated = [];

      this.loadnoSpecific.items.items.forEach(element => {
        var p = {
          lat: element.latitude,
          lng: element.longitude,
          done: element.done
        };
        points.push(p);
      });

      this.completeTour.contracts.forEach(element => {
        var c = element.customer.position;
        var p = {
          lat: c.lat,
          lng: c.lng,
          done: element.done,
          customer: element.customer
        };
        pointsCalculated.push(p);
      });

      const drv = this.completeTour.location;
      const drivermarker = { lat: drv.latitude, lng: drv.longitude };

      var waypoints = { driver: drivermarker, tour: points, calculatedTour: pointsCalculated };

      console.log('points: ');
      console.log(waypoints);

      return waypoints;
    },
    switchLabel() {
      return this.showCalculatedTour ? 'errechnete Route' : 'gefahrene Route';
    }
  },
  data() {
    return {
      buttonActive: true,
      mapKey: 0,
      tableKey: 0,
      updateValues: false,
      showCalculatedTour: true,
      showDrivenTour: true,
      googleWaypoints: [],
      drivenWaypoints: [],
      expand: false,
      showMarker: false,
      perPageText: 'pro Seite',
      completeTourLoading: true,
      tmploadno: null,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 30,
        sortBy: 'sorting'
      },
      selectedContract: {},
      headers: [
        {
          text: '#',
          align: 'left',
          sortable: true,
          value: 'sorting'
        },
        {
          text: 'Auftrag',
          align: 'left',
          sortable: true,
          value: 'contractNumber'
        },
        {
          text: 'Absatzstätte',
          align: 'left',
          sortable: true,
          value: 'absa'
        },
        {
          text: 'Kunde',
          align: 'right',
          sortable: true,
          value: 'customer'
        },
        {
          text: 'Erledigt/Gelöscht',
          align: 'right',
          sortable: true,
          value: 'doneAt'
        }
      ]
    };
  },
  watch: {
    completeTour(newValue, oldValue) {
      if (newValue != null && this.updateValues) {
        setTimeout(() => {
          this.updateKeys();
        }, 3000);
      }
    }
  },
  methods: {
    updateKeys() {
      this.updateValues = false;
    },
    refresh() {
      this.buttonActive = false;
      setTimeout(() => {
        this.buttonActive = true;
      }, 30000);

      if (this.tmploadno == null) {
        this.tmploadno = this.completeTour.loadno;
      }
      this.updateValues = true;
      const loadno = this.tmploadno;
      this.$store.dispatch('tours/getCompleteTour', { loadno });
    },
    deliveredOrDeleted(item) {
      if (item.done) {
        return 'Erledigt um: ' + this.$options.filters.formatDate(item.doneAt);
      } else if (item.deleted) {
        return (
          'Gelöscht um ' +
          this.$options.filters.formatDate(item.deletedAt) +
          ', Grund: ' +
          item.deleteReason
        );
      } else {
        return '';
      }
    },
    doneCount() {
      var newArray = this.completeTour.contracts.filter(function(element) {
        return element.done === true;
      });
      return newArray != null ? newArray.length : 0;
    },
    openCount() {
      var newArray = this.completeTour.contracts.filter(function(element) {
        return element.done !== true;
      });
      return newArray != null ? newArray.length : 0;
    }
  }
};
</script>
<style scoped>
.deleted {
  background-color: lightcoral;
}
.finished {
  background-color: lightgreen;
}
#map {
  height: 50%;
}
</style>
